// src/utils/requestRowDisplay.js
//
// Cell-level display rules for the Raw requests table (Slot Story step 4).
// Pure, so both capture paths are testable without mounting the 5000-line view.

export const USB_CODE_TIP = 'Response status is not visible in USB capture';

const isLogcat = (row) => !!(row && row.captureSource === 'logcat');

/**
 * Code cell.
 *  - USB/logcat row: empty, with the tooltip. Never "-" (reads as an error) and
 *    never a red code: logcat carries no response.
 *  - MITM row with a status: the status.
 *  - MITM row with NO status (request failed / no response): "ERR" with the
 *    reason when the row has one. Never blank.
 * -> { text, title, usb, failed, status }
 */
export function codeCellFor(row) {
  if (isLogcat(row)) return { text: '', title: USB_CODE_TIP, usb: true, failed: false, status: null };
  const raw = row ? (row.status != null ? row.status : row.responseCode) : null;
  const n = Number(raw);
  if (raw != null && raw !== '' && Number.isFinite(n) && n > 0) {
    return { text: String(n), title: '', usb: false, failed: false, status: n };
  }
  const why = row && (row.error || row.errorMessage || row.failureReason);
  return {
    text: 'ERR',
    title: why ? String(why) : 'No response was received for this request',
    usb: false,
    failed: true,
    status: 0,
  };
}

/** Method badge text for the Type / Format cell: only for non-GET rows. */
export function methodBadgeFor(row) {
  const m = row && typeof row.method === 'string' ? row.method.trim().toUpperCase() : '';
  return m && m !== 'GET' ? m : null;
}
